import React from "react";
import { Box, Stack, Typography, Chip } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import {
  EVALUATION_ROLE_COLORS,
  getEditableCriteria,
  getEvaluationRoleLabel,
  isOverviewViewer,
} from "../constants";

export default function RoleBanner({ user, role }) {
  const roleStyle = EVALUATION_ROLE_COLORS[role] || { color: "#556677", bg: "#f0f2f5" };
  const editable = getEditableCriteria(role);
  const isOverview = isOverviewViewer(role);
  const userName = user?.name || user?.email || "Usuario";

  const permissionLabel = (() => {
    if (role === "rh") return "Puedes calificar y supervisar";
    if (role === "admin") return "Puedes calificar y supervisar";
    return "Puedes calificar";
  })();

  return (
    <Box
      sx={{
        mb: 3,
        p: { xs: 2, sm: 2.5 },
        borderRadius: "14px",
        border: "1px solid #e8eaef",
        bgcolor: "#fafbfc",
        background: "linear-gradient(135deg, #fafbfc 0%, #f5f7fb 100%)",
      }}
    >
      <Stack
        direction={{ xs: "column", md: "row" }}
        spacing={2}
        alignItems={{ xs: "stretch", md: "center" }}
        justifyContent="space-between"
      >
        <Stack direction="row" spacing={2} alignItems="center">
          <Box
            sx={{
              width: 48,
              height: 48,
              borderRadius: "12px",
              bgcolor: "#eef5fd",
              color: "#1975d1",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <AssignmentIndIcon sx={{ fontSize: 24 }} />
          </Box>
          <Box>
            <Typography
              variant="overline"
              sx={{ color: "#9ca3af", fontWeight: 700, letterSpacing: "0.08em", lineHeight: 1.2 }}
            >
              Tu identidad en esta evaluación
            </Typography>
            <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap" useFlexGap sx={{ mt: 0.5 }}>
              <PersonIcon sx={{ fontSize: 18, color: "#6b7280" }} />
              <Typography sx={{ fontWeight: 700, color: "#111827", fontSize: "1rem" }}>
                {userName}
              </Typography>
              <Chip
                label={getEvaluationRoleLabel(role).toUpperCase()}
                size="small"
                sx={{
                  fontWeight: 700,
                  fontSize: "0.65rem",
                  letterSpacing: "0.04em",
                  color: roleStyle.color,
                  bgcolor: roleStyle.bg,
                  height: 24,
                }}
              />
            </Stack>
          </Box>
        </Stack>

        <Box sx={{ minWidth: 0 }}>
          <Typography
            variant="caption"
            sx={{
              display: "block",
              color: "#9ca3af",
              fontWeight: 600,
              letterSpacing: "0.04em",
              textTransform: "uppercase",
              mb: 0.75,
            }}
          >
            {permissionLabel}
          </Typography>
          <Stack direction="row" spacing={0.75} flexWrap="wrap" useFlexGap>
            {role === "admin" ? (
              <>
                <Chip label="Cumplimiento administrativo" size="small" sx={chipSx("#8b5cf6")} />
                <Chip label="Ver todas las calificaciones" size="small" sx={chipSx("#1975d1")} />
              </>
            ) : role === "rh" ? (
              <>
                <Chip label="Calidad del servicio" size="small" sx={chipSx("#6366f1")} />
                <Chip label="Puntualidad" size="small" sx={chipSx("#0ea5e9")} />
                <Chip label="Actitud" size="small" sx={chipSx("#10b981")} />
              </>
            ) : isOverview && editable.length === 0 ? (
              <Typography variant="body2" sx={{ color: "#6b7280" }}>
                Sin criterios asignados a tu rol
              </Typography>
            ) : editable.length === 0 ? (
              <Typography variant="body2" sx={{ color: "#6b7280" }}>
                Sin criterios asignados a tu rol
              </Typography>
            ) : (
              editable.map((c) => (
                <Chip key={c.id} label={c.label} size="small" sx={chipSx(c.color)} />
              ))
            )}
          </Stack>
        </Box>
      </Stack>
    </Box>
  );
}

function chipSx(color) {
  return {
    fontWeight: 600,
    fontSize: "0.75rem",
    color,
    bgcolor: `${color}14`,
    border: `1px solid ${color}33`,
    height: 28,
  };
}
